<template>
  <v-container fluid>
    <PageHeaderSlot>
      <template slot="top-right-slot">
        <small v-if="!gDisableSettingByCenter && schoolName">{{ $t('campus') }}: {{ schoolName }}</small>
      </template>
    </PageHeaderSlot>

    <v-form ref="dataForm" @submit.prevent="">
      <v-card class="mb-4">
        <v-card-text class="px-2">
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormUploader
                uploadText="uploadLogo"
                fileInputKey="upload_logo"
                :files.sync="formData.logo_list"
                dispatchUpdateOnChange
                single
                :readonly="!canEdit"
              />
            </v-col>

            <v-col cols="12">
              <FormTextarea
                label="invoiceRemark"
                :fieldValue.sync="formData.custom_text"
                dispatchUpdateOnChange
                :readonly="!canEdit"
              />
            </v-col>
          </v-row>

          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                label="phone"
                placeholder="phone"
                :fieldValue.sync="formData.phone"
                dispatchUpdateOnChange
                :readonly="!canEdit"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" v-if="!isAppMode(['T01'])">
              <FormInput
                label="whatsappNumber"
                placeholder="whatsappNumber"
                :fieldValue.sync="formData.whatsapp_number"
                dispatchUpdateOnChange
                :readonly="!canEdit"
              />
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3" v-if="isAppMode(['DEV'])">
              <template v-if="whatsappConnected">
                <FormButton text="unlink" @click="whatsappUnlink()" />
              </template>
              <template v-if="!whatsappConnected">
                <!-- whatsappLink -->
                <FormButton text="link" @click="whatsappLink()" />
                <template v-if="whatsappQR!=''">
                  <img style="width: 300px; height: 300px" :src="whatsappQR" />
                </template>
              </template>
            </v-col>
          </v-row>

          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                type="email"
                label="email"
                placeholder="email"
                :fieldValue.sync="formData.email"
                dispatchUpdateOnChange
                :readonly="!canEdit"
              />
            </v-col>

            <v-col cols="12" v-if="enableMultiNotifyEmail">
              <Datatable
                tableName="notifyEmail"
                :tableData.sync="formData.admin_notification_email"
                :tableHeaders="emailTableHeaders"
                disablePagination
                @delete-clicked="handleDeleteEmail($event)"
                :enableDrag="canEdit"
                dispatchUpdateOnChange
              >
                <template slot="append-toolbar-left">
                  <FormButton v-if="canEdit" text="add" class="ml-4 my-2" @click="handleAddEmail()" isAdd />
                </template>
                <template v-slot:[`item.email`]="{ item }">
                  {{ item.email }}
                  <v-btn icon text depressed x-small @click.prevent="gfCopyText(item.email)">
                    <v-icon class="fi fi-rr-copy" size="15" color="primary"></v-icon>
                  </v-btn>
                </template>
              </Datatable>
            </v-col>

            <v-col cols="12">
              <FormTextarea
                label="defaultWhatsappMsg"
                :fieldValue.sync="formData.whatsapp_message"
                dispatchUpdateOnChange
                :readonly="!canEdit"
              />
            </v-col>

            <v-col cols="12" v-if="isAppMode(['T03', 'T20', 'T21'])">
              <FormTextarea
                label="enrollTerms"
                :fieldValue.sync="formData.member_terms_field"
                dispatchUpdateOnChange
                :readonly="!canEdit"
              />
            </v-col>

            <v-col cols="12" v-if="isAppMode(['T36'])">
              <FormTextarea
                label="paymentTerms"
                :fieldValue.sync="formData.payment_terms"
                dispatchUpdateOnChange
                :readonly="!canEdit"
              />
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3" v-if="gEnableRegularPeriod">
              <FormSelect
                label="regularCoursePeriod"
                placeholder="regularCoursePeriod"
                :fieldValue.sync="formData.month_period"
                dispatchUpdateOnChange
                :options="lessonPeriodOptions"
                required
                :readonly="!canEdit"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card class="mt-4" v-if="enableCustomRegisterForm">
        <v-card-title class="text-subtitle-1 colorBlack--text font-weight-medium text-capitalize">
          {{ $t('registerForm') }}<small class="text-caption text-lowercase">{{ $t('registerFormDes') }}</small>
        </v-card-title>
        <v-card-text>
          <div class="d-flex align-center">
            <FormButton text="openRegisterForm" class="mr-2 mb-4" @click="openRegisterForm()" />
            <FormButton text="copyRegisterFormLink" class="mb-4" @click="copyRegisterFormLink()" />
          </div>
          <FormButton v-if="canEdit" text="editRegisterForm" @click="handleEditRegisterForm()" />
        </v-card-text>
      </v-card>

      <div class="d-flex align-center mt-4" v-if="canEdit">
        <FormButton @click="save()" />
      </div>
    </v-form>

    <!-- Modal: 接收通知電郵 -->
    <FormDialog
      v-if="enableMultiNotifyEmail"
      :maxWidth="500"
      title="notifyEmail"
      ref="emailFormDialog"
      formRef="emailForm"
    >
      <v-row class="ma-0">
        <v-col cols="12">
          <FormInput type="email" label="email" placeholder="email" :fieldValue.sync="addEmail" required />
        </v-col>
      </v-row>
    </FormDialog>

    <!-- Modal: 修改報名表連結 -->
    <FormDialog
      v-if="enableCustomRegisterForm"
      title="editRegisterForm"
      ref="editRegisterFormDialog"
      formRef="editRegisterForm"
    >
      <v-row class="ma-0">
        <v-col cols="12" class="px-0">
          <Datatable
            :tableData="registerForm.tableData"
            :tableHeaders="registerFormHeaders"
            disablePagination
            :breakpoint="0"
          >
            <template v-slot:[`item.show`]="{ item }">
              <v-checkbox
                v-model="item.show"
                :label="$t(item.label, item.label_props)"
                color="primary"
                hide-details
                class="my-0 py-0 title-checkbox"
              ></v-checkbox>
            </template>
            <template v-slot:[`item.required`]="{ item }">
              <v-checkbox
                v-model="item.required"
                :label="$t('required')"
                color="primary"
                hide-details
                class="my-0 py-0 small-checkbox"
              ></v-checkbox>
            </template>
          </Datatable>
        </v-col>
        <v-col cols="12" md="6">
          <FormSelect
            label="needStudentSign"
            placeholder="needStudentSign"
            :fieldValue.sync="registerForm.need_sign"
            :options="needOptions"
            required
          />
        </v-col>
        <v-col cols="12">
          <FormTextarea label="enrollTermsZH" :fieldValue.sync="registerForm.terms_zh" />
        </v-col>
        <v-col cols="12">
          <FormTextarea label="enrollTermsEN" :fieldValue.sync="registerForm.terms_en" />
        </v-col>
      </v-row>
    </FormDialog>
  </v-container>
</template>

<script>
import FormTextarea from '@/components/formField/FormTextarea.vue'
import FormInput from '@/components/formField/FormInput.vue'
import FormSelect from '@/components/formField/FormSelect.vue'
import Datatable from '@/components/Datatable.vue'
import FormDialog from '@/components/FormDialog.vue'
import FormUploader from '@/components/formField/FormUploader.vue'
import FormButton from '@/components/layout/FormButton.vue'
import fields from '../Student/components/fields'

export default {
  name: 'BasicSetting',
  components: {
    FormTextarea,
    FormInput,
    FormSelect,
    Datatable,
    FormDialog,
    FormUploader,
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    initLogo: '',
    formData: {
      logo_list: [],
      custom_text: '',
      phone: '',
      email: '',
      whatsapp_message: '',
      member_terms_field: '',
      whatsapp_number: '',
      month_period: 1,
      admin_notification_email: [],
      payment_terms: '',
    },

    schoolName: '',

    addEmail: '',

    registerForm: {
      tableData: [],
      need_sign: false,
      terms_zh: '',
      terms_en: '',
    },

    lessonPeriodOptions: [
      { value: 1, text: vm.$t('monthPerPeriod', { month: 1 }) },
      { value: 2, text: vm.$t('monthPerPeriod', { month: 2 }) },
      { value: 3, text: vm.$t('monthPerPeriod', { month: 3 }) },
    ],
    registerFormHeaders: [
      { value: 'show', text: '' },
      { value: 'required', text: vm.$t('required'), width: 150 },
    ],
    needOptions: [
      { value: true, text: vm.$t('need') },
      { value: false, text: vm.$t('noNeed') },
    ],
    whatsappConnected: false,
    whatsappQR: "",
  }),
  computed: {
    emailTableHeaders() {
      const vm = this
      const headers = [{ value: 'email', text: vm.$t('email') }]
      if (this.canEdit) {
        headers.push({ value: 'minActionDelete', text: '', align: 'end' })
      }
      return headers
    },
    // permission & setting
    enableMultiNotifyEmail() {
      return this.isAppMode(['DEV', 'T02'])
    },
    enableCustomRegisterForm() {
      return this.isAppMode(['DEV', 'UAT', 'T37', 'T40', 'T45', 'T46', 'T49', 'T50', 'T56', '58+'])
    },
    canEdit() {
      // [T46] admin account 只可read
      return !this.isAppMode(['T46']) || this.userType !== 'admin'
    },
  },
  methods: {
    async getSchool() {
      const selectedSchool = this.gfGetUserSelectedSchool()
      if (selectedSchool > -1) {
        try {
          const data = await this.$Fetcher.GetSchoolById(selectedSchool)
          this.schoolName = data.name
          if (!data.basic_use_share) {
            this.insertData(data)
          } else {
            await this.getSetting()
          }
        } catch (err) {
          this.$common.error(err)
        }
      }
      this.$store.dispatch('toggleLoadingPage', false)
    },
    async getSetting() {
      try {
        const data = await this.$Fetcher.GetSetting()
        this.insertData(data)
      } catch (err) {
        this.$common.error(err)
      } finally {
        this.$store.dispatch('toggleLoadingPage', false)
      }
    },
    insertData(data) {
      for (const key in this.formData) {
        if (this.$validate.DataValid(data[key])) {
          this.formData[key] = data[key]
        }
      }
      this.formData.logo_list = []
      if (data['logo']) {
        this.formData.logo_list.push({ name: data['logo'], file: data['logo'] })
      }
      this.initLogo = data['logo'] || ''
      if (data.admin_notification_email) {
        this.formData.admin_notification_email = data.admin_notification_email.map(el => {
          return {
            id: el,
            email: el,
          }
        })
      }
    },

    async save() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      if (!this.canEdit) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }

      if (!this.gDisableSettingByCenter) {
        const check = await this.gfCheckSchoolSelected()
        if (!check) return
      }

      const valid = this.$refs['dataForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', { message: 'required' })
        return
      }

      this.$store.dispatch('setLoading', true)
      let payload = {
        logo: this.formData.logo_list.length ? this.formData.logo_list[0].file : '',
        custom_text: this.formData.custom_text,
        phone: this.formData.phone,
        email: this.formData.email,
        whatsapp_message: this.formData.whatsapp_message,
        member_terms_field: this.formData.member_terms_field,
        whatsapp_number: this.formData.whatsapp_number,
        payment_terms: this.formData.payment_terms,
      }

      if (this.gEnableRegularPeriod) {
        payload['month_period'] = this.formData.month_period
      }

      if (this.isAppMode(['DEV', 'T02'])) {
        payload['admin_notification_email'] = this.formData.admin_notification_email.map(el => el.email)
      }

      try {
        if (!this.gDisableSettingByCenter) {
          const selectedSchool = this.gfGetUserSelectedSchool()
          await this.$Fetcher.UpdateSchool(selectedSchool, payload)
        } else {
          await this.$Fetcher.UpdateSetting(payload)
        }
        // update local logo
        if (payload.logo !== this.initLogo) {
          this.gfUpdateSettingLogo(payload.logo);
        }
        this.$store.dispatch('setDataIsUpdated', false)
        this.$store.dispatch('toggleSnack', {
          message: 'message.saveSuccessInMinutes',
          type: 'success',
          refresh: true,
        })
      } catch (err) {
        this.$common.error(err)
        this.showAlert({
          title: 'message.saveFail',
          message: err,
          isError: true,
        })
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },

    // ======== 接收通知電郵 ========
    async handleAddEmail(newOpen = true) {
      if (newOpen) {
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }
        this.addEmail = ''
        await this.$refs.emailFormDialog.resetForm()
      } else {
        this.$refs.emailFormDialog.setLoading(false)
      }

      const confirm = await this.$refs.emailFormDialog.show()
      if (confirm) {
        const email = this.addEmail.trim()
        const foundSame = this.formData.admin_notification_email.find(
          el => el.email.trim().toLowerCase() === email.toLowerCase(),
        )
        if (foundSame) {
          this.$store.dispatch('toggleSnack', { type: 'error', message: 'message.emailExist' })
          this.handleAddEmail(false)
          return
        }

        this.formData.admin_notification_email.unshift({ id: email, email: email })
        this.$store.dispatch('setDataIsUpdated', true)

        this.$refs.emailFormDialog.hide()
      }
    },

    handleDeleteEmail(email) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      const foundPos = this.formData.admin_notification_email.findIndex(el => el.email === email)
      if (foundPos > -1) {
        this.formData.admin_notification_email.splice(foundPos, 1)
        this.$store.dispatch('setDataIsUpdated', true)
      }
    },

    // ======== 學生報名表 ========
    _getRegisterLink() {
      if (this.$validate.DataValid(this.$config.VUE_APP_REGISTER_LINK_DOMAIN)) {
        return `${this.$config.VUE_APP_REGISTER_LINK_DOMAIN}/register.php`
      } else if (this.$validate.DataValid(this.$config.VUE_APP_PAYMENT_LINK_DOMAIN)) {
        return `${this.$config.VUE_APP_PAYMENT_LINK_DOMAIN}/register.php`
      }
      return ''
    },
    // -- (打開報名表連結)
    async openRegisterForm() {
      const getLnk = this._getRegisterLink()
      if (getLnk) {
        window.open(getLnk, '_target')
      }
    },
    // -- (複製報名表連結)
    copyRegisterFormLink() {
      const vm = this
      const getUrl = new Promise((resolve, reject) => {
        const url = vm._getRegisterLink()
        resolve(url)
      })
      this.gfCopyText(getUrl)

      this.$store.dispatch('setLoading', false)
    },

    // -- (修改報名表連結)
    async handleEditRegisterForm(newOpen = true) {
      if (newOpen) {
        if (this.$store.getters.isLoading) {
          this.$store.dispatch('toggleSnack', { message: 'processing' })
          return
        }

        // get fields
        this.registerForm.tableData = []

        fields.forEach(item => {
          const show =
            !item.hide_register &&
            !(this.$validate.DataValid(item.modes, true) && !this.isAppMode(item.modes)) &&
            !(this.$validate.DataValid(item.except_modes, true) && this.isAppMode(item.except_modes)) &&
            !(item.key === 'school_id' && this.gDisableStudentCenter)

          if (show) {
            let labelProps = item.label_props || {}
            if (
              item.key === 'contact_person_1_name' ||
              item.key === 'contact_person_1_phone' ||
              item.key === 'contact_person_1_email'
            ) {
              labelProps = { number: 1, relationship: this.$t(this.isAppMode(['T21']) ? 'parent' : 'father') }
            } else if (
              item.key === 'contact_person_2_name' ||
              item.key === 'contact_person_2_phone' ||
              item.key === 'contact_person_2_email'
            ) {
              labelProps = { number: 2, relationship: this.$t(this.isAppMode(['T21']) ? 'emergency' : 'mother') }
            } else if (
              item.key === 'contact_person_3_name' ||
              item.key === 'contact_person_3_phone' ||
              item.key === 'contact_person_3_email'
            ) {
              labelProps = { number: 3, relationship: this.$t('emergency') }
            }

            this.registerForm.tableData.push({
              label: item.label,
              label_props: labelProps,
              key: item.key,
              show: false,
              required: false,
            })
          }
        })

        try {
          const data = await this.$Fetcher.GetSetting()
          if (this.$validate.DataValid(data.student_field, true)) {
            data.student_field.forEach(item => {
              this.registerForm.tableData.push({
                label: this.$i18n.locale === 'en' ? item.field_name_en : item.field_name_zh,
                label_props: {},
                key: item.field_key,
                show: false,
                required: false,
              })
            })
          }

          this.registerForm.need_sign = data.application_sign_required || false
          this.registerForm.terms_zh = data.application_terms_and_conditions_zh || ''
          this.registerForm.terms_en = data.application_terms_and_conditions_en || ''

          if (this.$validate.DataValid(data.application_fields, true)) {
            for (let i = 0; i < this.registerForm.tableData.length; i++) {
              const found = data.application_fields.find(el => el.field_key === this.registerForm.tableData[i].key)
              if (found) {
                this.registerForm.tableData[i].show = true
                if (found.required) {
                  this.registerForm.tableData[i].required = true
                }
              }
            }
          }
        } catch (err) {
          this.$common.error(err)
        }
      } else {
        this.$refs.editRegisterFormDialog.setLoading(false)
      }
      const confirm = await this.$refs.editRegisterFormDialog.show()
      if (confirm) {
        try {
          const payload = {
            application_fields: [],
            application_sign_required: this.registerForm.need_sign || false,
            application_terms_and_conditions_zh: this.registerForm.terms_zh || '',
            application_terms_and_conditions_en: this.registerForm.terms_en || '',
          }

          this.registerForm.tableData.forEach(item => {
            if (item.show) {
              payload['application_fields'].push({
                field_key: item.key,
                required: item.required || false,
              })
            }
          })

          await this.$Fetcher.UpdateSetting(payload)
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })
          this.$refs.editRegisterFormDialog.hide()
        } catch (err) {
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
          this.handleEditRegisterForm(false)
        }
      }
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: BasicSetting')
      this.userType = this.gfGetUserType(true)
      this.whatsappLink(true);
      if (!this.gDisableSettingByCenter) {
        await this.gfCheckSchoolSelected(true)
        this.getSchool()
      } else {
        this.getSetting()
      }
    },

    async whatsappLink(init = false) {
      const data = await this.$Fetcher.LinkWhatsapp()
      console.log(data)
      if(data.status == "pending"){
        this.whatsappConnected = false;
        if(!init){
          this.whatsappQR = data.qr;
        }
      }else if(data.error == "already linked"){
        this.whatsappConnected = true;
      }
    },

    async whatsappUnlink(init = false) {
      const data = await this.$Fetcher.UnlinkWhatsapp()
      console.log(data)
      if(data.status == "unlinked"){
        this.whatsappConnected = false;
      }
    },
  },

  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else if (this.$store.getters.dataIsUpdated) {
      this.$store.dispatch('showLeaveAlert', { toLink: { name: to.name } })
      next(false)
    } else {
      next()
    }
  },
}
</script>
<style lang="scss" scoped>
::v-deep.small-checkbox {
  & label {
    color: var(--v-colorBlack-base);
    font-weight: 500;
    font-size: 0.875rem;
  }
}
::v-deep.title-checkbox {
  & label {
    color: var(--v-colorBlack-base);
    font-weight: 500;
    font-size: 0.875rem;
    width: 250px;
  }
}
</style>
